import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import { standardFieldsLabels } from 'hb-react/shared/apps/Events/utils/standardFieldsLabels';
import {
  Telephone,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

const Field = ({
  Component,
  id,
  label,
  labelMultiline,
  name,
  onUpdate,
  placeholder,
  required,
}) => (
  <Component
    data-testid={id}
    name={name}
    label={label}
    labelMultiline={labelMultiline}
    placeholder={placeholder}
    onChange={(value) => onUpdate(value)}
    validate={{
      required,
    }}
  />
);

const FieldTypes = {
  mobile_phone: Telephone,
};

const StandardFields = ({
  name,
  fields = {},
  onUpdate = () => {},
  Wrapper = Box,
}) => {
  const standardFields = useMemo(() => Object.values(fields), [fields]);

  return standardFields.length > 0
    ? standardFields.map(({ label, id, name: fieldName, ...props }) => (
        <Wrapper key={id}>
          <Field
            Component={FieldTypes[fieldName] || Text}
            id={id}
            name={`${name}[${fieldName}]`}
            label={label || standardFieldsLabels[fieldName]}
            labelMultiline
            onUpdate={(value) => onUpdate({ [fieldName]: value })}
            {...props}
          />
        </Wrapper>
      ))
    : null;
};

StandardFields.propTypes = {
  name: PropTypes.string.isRequired,
  fields: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string,
      placeholder: PropTypes.string,
      required: PropTypes.bool,
    }),
  ),
  onUpdate: PropTypes.func,
};

export default StandardFields;
